module.exports = __webpack_public_path__ + "img/new-books.155fe791.jpg";